module.exports = __webpack_public_path__ + "img/brands-barilla-hero.jpg?3b38f96fbbd9d477a00d65c1453d4239";